import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { Constants } from 'src/app/constants';
import { AddQueueDialogComponent } from 'src/app/core/dialogs/add-queue-dialog/add-queue-dialog.component';
import { CopyTierDialogComponent } from 'src/app/core/dialogs/copy-tier-dialog/copy-tier-dialog.component';
import { DeleteDialogComponent } from 'src/app/core/dialogs/delete-dialog/delete-dialog.component';
import { ExclusionParametersDialogComponent } from 'src/app/core/dialogs/exclusion-parameters-dialog/exclusion-parameters-dialog.component';
import { BtnCellRendererEditDelete } from 'src/app/core/grid/btn-cell-render-edit-delete';
import { GroupIStateService } from 'src/app/service/groupi-state.service';
import { EWConfigurationService } from 'src/app/service/management/ew-configuration.service';

@Component({
    selector: 'app-ewconfiguration',
    templateUrl: './ewconfiguration.component.html',
    styleUrls: ['./ewconfiguration.component.scss'],
    standalone: false
})
export class EWConfigurationComponent implements OnInit {
  gridApi: any;
  icons;
  columnDefs;
  displayRowData = [];
  context: any;
  currentPageNo: any;
  currentPageBoolean: boolean = false;
  totalPage: any;
  currentPageForTotalPage: any;
  isLastPageFound: any;
  rowCount;

  selected_period_id;
  selected_period_value
  defaultColDef;
  successMessage
  errorMessage

  domicileRouteMasterList = []
  ewconfigurelist = []
  isAccessible = true;
  isFirstTimeLoad = true;

  constructor(private readonly router: Router, public dialog: MatDialog, private readonly ewconfigureService: EWConfigurationService,
    private readonly ngxUiLoaderService : NgxUiLoaderService, private readonly constants: Constants, private readonly groupIStateService : GroupIStateService) {
    this.context = {
      componentParent: this
    };

    this.defaultColDef = {
      suppressMovable: true, wrapText: true, floatingFilter: true,
      filterParams: {
        newRowsAction: 'keep'
      },
      suppressHeaderFilterButton: true ,suppressCellSelection: true
    }
  }

  ngOnInit(): void {

    this.ngxUiLoaderService.start(this.constants.LoaderInitializer);
    this.columnDefs = [
      // {
      //   headerName: "ID", field: "ewID",
      //   autoHeight: true
      // },
      {
        headerName: "E/W", field: "description", cellClass: "left_align", width: 270, floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter'
      },
      {
        headerName: "Alarm_ID", field: "alarmID", width: 40, floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter'
      },
      {
        headerName: "Parameter", field: "parameters", cellClass: "left_align", width: 250, floatingFilterComponentParams: { suppressFilterButton: true },
        filter: 'agTextColumnFilter'
      },
      {
        headerName: "Edit / Delete", field: "ewconfiguration_editdelete",
         cellRenderer: BtnCellRendererEditDelete, width: 50
      }];
    this.icons = {
      sortUnSort: '<img src="./assets/images/unsort.svg">',
    };
    // this.checkRoles();
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
  }
  async checkRoles() {
    await this.groupIStateService.getRoles();
    const roles = this.groupIStateService.getroleState();
    const userRoles = JSON.parse(roles);
    this.ngxUiLoaderService.stop(this.constants.LoaderInitializer);
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerAdmin)) {
    //   this.isAccessible = true;
    // } else {
    //   this.openRouteLevel('home');
    // }
  }

  componentEventHandler(event) {

    if (event.eventType == "NOTIFICATION_ERROR") {  // NOSONAR
      this.errorMessage = event.eventMessage;
      setTimeout(() => {
        this.successMessage = "";
        this.errorMessage = "";
      }, this.constants.notificationMessageTime);
    } else if (event.eventType == "CHANGE_PERIOD") {  // NOSONAR
      this.selected_period_id = event.periodId
      this.selected_period_value = event.periodValue
      this.refreshData();
    }
  }
  async getBaseDropDownDataAPI() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    this.ewconfigurelist = []
    this.domicileRouteMasterList = []
    await this.ewconfigureService.getDomicileRouteList().then((x) => {
      if (x && x.length > 0) {
        this.domicileRouteMasterList = x;
      }
    })
    await this.ewconfigureService.getEWList().then(x => {
      if (x.length > 0) {

        x.forEach((obj, index) => {
          if (obj != null) // NOSONAR
           {this.ewconfigurelist.push({ id: index + 1, value: obj })}
        })
        this.ewconfigurelist.sort((a, b) => (a.value > b.value ? 1 : -1))
      }
    })
    this.isFirstTimeLoad = false;
    this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
  }

  refreshData() {
    this.ngxUiLoaderService.start(this.constants.LoaderComponent)
    this.ewconfigureService.loadDataEWConfiguration(this.selected_period_id).subscribe(
      response => {

        this.displayRowData = response;
        if (response.length > 0) {
          this.displayRowData.forEach((element, index) => {
            this.displayRowData[index].parameters = "Route: " + element.route + " / Route Date: " + element.routeDate + " / Domiciles: " + element.domicile
          })
        }
        const model = this.gridApi?.getFilterModel();
        this.gridApi?.setGridOption('rowData', this.displayRowData)
        this.rowCount = this.displayRowData.length;
        this.gridApi?.setFilterModel(model);
        if (this.isFirstTimeLoad) {this.getBaseDropDownDataAPI();}
        else {this.ngxUiLoaderService.stop(this.constants.LoaderComponent)}
      }, _error => {
        this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
        this.errorMessage = this.constants.APIErrorMessage;
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTime);
      }
    );

  }
  sizeToFit() { this.gridApi?.sizeColumnsToFit(); }
  onGridReady(params) {
    this.gridApi = params.api
    this.gridApi.sizeColumnsToFit();
  }
  onPageSizeChanged(event: any) {
    if (event.target.value == "ALL")  // NOSONAR
    {
      this.gridApi?.setGridOption('paginationPageSize', Number(this.displayRowData.length));
    }
    else
    {
      this.gridApi?.setGridOption('paginationPageSize', Number(event.target.value));
    }
  }
  goToNexpage() { this.gridApi.paginationGoToNextPage(); }

  goToPreviousPage() { this.gridApi.paginationGoToPreviousPage()  }

  goToFirstPage() { this.gridApi.paginationGoToFirstPage(); }

  goToLastPage() { this.gridApi.paginationGoToLastPage()  }

  getCurrentPage(): boolean {
    this.currentPageNo = this.gridApi?.paginationGetCurrentPage();
    if (this.currentPageNo == 0) {  // NOSONAR
      this.currentPageBoolean = true;
    }
    else { this.currentPageBoolean = false; }
    return this.currentPageBoolean;
  }
  isLastPage(): boolean {
    this.totalPage = Number(this.gridApi?.paginationGetTotalPages());
    this.currentPageForTotalPage = Number(this.gridApi?.paginationGetCurrentPage()) + 1;
    if (this.totalPage == this.currentPageForTotalPage) {  // NOSONAR
      this.isLastPageFound = true;
    }
    else {
      this.isLastPageFound = false;
    }
    return this.isLastPageFound;
  }
  editTemplateRow(data, pagename) {

    if (pagename == 'ewconfiguration_editdelete') {  // NOSONAR
      this.editDialog('edit-ewconfiguration', data)
    }
  }
  deleteTemplateRow(data, pagename) {

    let displayRowIndex;
    if (pagename == 'ewconfiguration_editdelete') {  // NOSONAR

      const dialogRef = this.dialog.open(
        DeleteDialogComponent, {
        disableClose: true,
        width: '500px',
        height: '170px',
        data: {
          header: 'Are you sure you want to delete this E/W?',
          description: data.description,
        }
      });
      dialogRef.afterClosed().subscribe(result => {

        if (result.event == 'ConfirmEvent') {  // NOSONAR
          this.ngxUiLoaderService.start(this.constants.LoaderComponent)
          this.ewconfigureService.deleteEWConfiguration(data.ewID).subscribe(
            response => {

              if (response == "Success") {  // NOSONAR
                this.successMessage = this.constants.APIDataDeleted;
                setTimeout(() => {
                  this.successMessage = "";
                  this.errorMessage = "";
                }, this.constants.notificationMessageTime);

                displayRowIndex = this.displayRowData.findIndex(x => x.ewID == data.ewID)  // NOSONAR
                this.displayRowData.splice(displayRowIndex, 1);
                this.gridApi?.setGridOption('rowData', this.displayRowData)
                this.rowCount = this.displayRowData.length;
              }
              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)

            }, _error => {

              this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
              this.errorMessage = this.constants.APIErrorMessage;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTime);
            }
          );
        }
      });

    }
  }
  editDialog(_event, data): void {

   

   const dialogRef = this.dialog.open(
      ExclusionParametersDialogComponent, {
      disableClose: true,
      width: '800px',
      height: '446px',
      data: {
        header: 'Exclusion Parameters',
        eventType: 'EDIT',
        ewID: data.ewID,
        description: data.description,
        alarmID: data.alarmID,
        parameters: data.parameters,
        domicile: data.domicile,
        route: data.route,
        routeDate: data.routeDate,
        ewconfigurelist: this.ewconfigurelist,
        domicileRouteMasterList: this.domicileRouteMasterList,
        selectedPeriodId: this.selected_period_id

      }
    });


    dialogRef.afterClosed().subscribe(result => {
      if (result.event == 'SaveEvent') { // NOSONAR
        this.successMessage = this.constants.APIDataUpdated
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTime);
        this.refreshData();
      }
    });
  }

  addDialog(): void {
    

    const dialogRef = this.dialog.open(
      ExclusionParametersDialogComponent, {
      disableClose: true,
      width: '800px',
      height: '446px',
      data: {
        header: 'Exclusion Parameters',
        eventType: 'ADD',
        selectedPeriodId: this.selected_period_id,
        ewconfigurelist: this.ewconfigurelist,
        domicileRouteMasterList: this.domicileRouteMasterList,
      }
    });


    dialogRef.afterClosed().subscribe(result => {
      if (result.event == 'SaveEvent') {  // NOSONAR
        this.successMessage = this.constants.APIDataSaved
        setTimeout(() => {
          this.successMessage = "";
          this.errorMessage = "";
        }, this.constants.notificationMessageTime);
        this.refreshData();
      }
    });
  }
  copyDialog(): void {
    const dialogRef = this.dialog.open(CopyTierDialogComponent, {
      disableClose: true,
      width: '500px',
      height: '240px',
      data: {
        header: 'Copy EW-Configuration',
        fromPeriodLabel: this.selected_period_value
      }
    });
    dialogRef.afterClosed().subscribe(result => {

      if (result.event == 'SaveEvent') {  // NOSONAR
        this.ngxUiLoaderService.start(this.constants.LoaderComponent)
        this.ewconfigureService.copyEWConfiguration(Number(this.selected_period_id), Number(result.selected_period_id)).subscribe(
          response => {
            if (response == "Success") {  // NOSONAR
              this.successMessage = this.constants.APIDataSaved;
              setTimeout(() => {
                this.successMessage = "";
                this.errorMessage = "";
              }, this.constants.notificationMessageTime);
            }
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
          }, _error => {
            this.ngxUiLoaderService.stop(this.constants.LoaderComponent)
            this.errorMessage = this.constants.APIErrorMessage;
            setTimeout(() => {
              this.successMessage = "";
              this.errorMessage = "";
            }, this.constants.notificationMessageTime);
          });

      }
    });
  }

  AddToQueue(): void {

    const dialogRef = this.dialog.open(AddQueueDialogComponent, {
      disableClose: true,
      width: '500px',
      height: '240px',
      data: { header: 'Add To Queue' }
    });

    dialogRef.afterClosed().subscribe(result => {
      this.ngxUiLoaderService.stop(this.constants.LoaderComponent);
      if (result.event == 'SaveEvent') {  // NOSONAR
        if (result.data == "Success") {  // NOSONAR
          this.successMessage = this.constants.APIAddToQueueSuccess;
          setTimeout(() => {
            this.successMessage = "";
            this.errorMessage = "";
          }, this.constants.notificationMessageTime);
        }
      }
    });
  }
  openRouteLevel(route) {
    this.router.navigate([`${route}`]);
  }

}
